import React, { useState, useEffect, useContext } from 'react';
import { useLoader, LoaderProvider } from "../../contexts/LoaderContext";
import axios from 'axios';
import { redirect, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import {useUser} from "../../contexts/UserContext"
import Error from '../../components/ui/alerts/ErrorDialog';

import SummerYouAltLogo from "../../assets/summeryou-alt-logo.png"

const SignIn = () => {
    // Loader 
    const {showLoader, hideLoader} = useLoader();
    const {user, setUser} = useUser();

    const navigate = useNavigate();
    const { login, isLoggedIn } = useContext(AuthContext);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ title : null, description : null});
    const [formData, setFormData] = useState({
        username : '',
        password : ''
    })    

    useEffect(() => {

        document.title = "Welcome to SummerYou"
        if (isLoggedIn) {
            navigate('/')
        }
    })

    const redirectSignUp = (e) => {
        e.preventDefault();
        navigate('/signup')
    }

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prev) => ({
            ...prev,
            [name] : value
        }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const baseUrl = process.env.REACT_APP_SUMMERYOULAB_API_URL;        
        
        showLoader();

        axios.post(`${baseUrl}/auth/signIn`, formData, {timeout: 30000})
            .then((res) => {
                const data = res.data.data;
                login({
                    token : data.token,
                    refreshToken : data.refreshToken,
                    username : data.userName
                });

                setUser({
                    username : data.username,
                    fullName : data.fullName,
                    initials : data.initials,
                    avatarUrl : data.initials || null
                })
            })
            .catch((error) => {
                if(error.status === 401) {setErrorMessage({ title : "Unrecognized combination!", description : 'Incorrect username or password  '})}
                else {setErrorMessage( {title : "An error occured while trying to sign in. Try again later.", description : null})}

                setShowError(true);
            })
            .finally (() => {
                hideLoader();
            })
  
               
    }


    return (
    <>
        <div className="flex min-h-full flex-1 flex-col justify-center py-7 sm:px-6 lg:px-8 font-inter">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-32 w-auto"
                    // src={SummerYouLogo}
                    src={SummerYouAltLogo}
                    alt="Your Company"
                />
                <h2 className="mt-3 text-center text-xl font-bold leading-9 tracking-tight text-gray-900">
                    Welcome to SummerYou!
                </h2>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-[480px]">
                <div className="bg-white px-6 py-10  sm:shadow sm:rounded-lg sm:px-12">
                    <form onSubmit={handleSubmit} className="space-y-6" action="#" method="POST">
                        <div>
                            <label htmlFor="username" className="block text-sm font-semibold leading-6 text-gray-900">
                                Username 
                            </label>
                            <div className="mt-2">
                                <input 
                                    type='text'
                                    name='username'
                                    value={formData.username}
                                    onChange={handleChange}
                                    required
                                    className="block w-full rounded-md border-0 py-2 px-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 required:border-pink-500 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                ></input>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="password" className="block text-sm font-semibold leading-6 text-gray-900">
                                Password 
                            </label>
                            <div className="mt-2">
                                <input 
                                    type='password'
                                    name='password'
                                    value={formData.password}
                                    onChange={handleChange}
                                    className="block w-full rounded-md border-0 py-2 px-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 required:border-pink-500 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    required
                                ></input>
                            </div>
                        </div>
                        <div>
                            <button 
                                type='submit'
                                className="block w-full rounded-md border-1 py-2.5 px-2.5 
                                bg-black text-white font-bold text-sm
                                text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300  focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            >
                                Sign In
                            </button>  
                            
                        </div>
                        
                        <div className="relative flex py-2 items-center">
                            <div className="flex-grow border-t border-gray-400"></div>
                            <span className="flex-shrink mx-4 text-gray-400">or</span>
                            <div className="flex-grow border-t border-gray-400"></div>
                        </div>
                               
                        <div>
                             <button 
                                type='button'
                                onClick={redirectSignUp}
                                className="block w-full rounded-md border-1 py-2 px-2 text-sm
                                bg-gray-100 font-semibold ring-1 ring-inset ring-gray-200 focus:ring-2 focus:ring-inset focus:ring-gray-300 sm:leading-6"
                            >
                                Sign Up Here!
                            </button>

                        </div>
                    </form>
                </div>
            </div>
        </div>


        { showError && <Error open={showError} onOpenChange={setShowError} title={errorMessage.title} description={errorMessage.description}/>

        }
    </>



    )
}

export default SignIn;